export const resizeImage = (
  file: File,
  maxWidth: number,
  maxHeight: number,
  targetSize: number,
): Promise<File> => {
  return new Promise((resolve, reject) => {
    const image = new Image()
    image.src = URL.createObjectURL(file)

    image.onload = () => {
      const { width, height } = image

      let scale = 1
      if (width > maxWidth || height > maxHeight) {
        scale = Math.min(maxWidth / width, maxHeight / height)
      }

      const newWidth = width * scale
      const newHeight = height * scale

      const canvas = document.createElement('canvas')
      canvas.width = newWidth
      canvas.height = newHeight

      const context = canvas.getContext('2d')
      context?.drawImage(image, 0, 0, newWidth, newHeight)

      let quality = 0.9
      const reduceQuality = () => {
        canvas.toBlob(
          (blob) => {
            if (!blob)
              return reject(new Error('Canvas failed to produce a blob'))

            if ((blob && blob.size <= targetSize) || quality <= 0.1) {
              const resizedFile = new File([blob], file.name, {
                type: file.type,
                lastModified: Date.now(),
              })

              resolve(resizedFile)
            } else {
              quality -= 0.1
              reduceQuality()
            }
          },
          file.type,
          quality,
        )
      }
      reduceQuality()
    }

    image.onerror = reject
  })
}
